import * as React from 'react';
import { Redirect, Route, Switch } from 'react-router';
import { Link } from 'react-router-dom';
import { AdminSchoolsInvitesInbox } from './AdminSchoolsInvitesInbox';
import { AdminSchoolsInvitesOutbox } from './AdminSchoolsInvitesOutbox';
import { AdminSchoolsInvitesArchive } from './AdminSchoolsInvitesArchive';
import './SchoolInvitesHub.scss';

export const SchoolInvitesRouting = allProps => {
  const pathname = allProps.location.pathname;
  const tabs = [
    { key: 'inbox', label: 'Inbox', description: 'Invitations received from other schools.' },
    { key: 'outbox', label: 'Outbox', description: 'Invitations your school has sent.' },
    { key: 'archive', label: 'Archive', description: 'Resolved, cancelled and expired invitations.' }
  ];

  React.useEffect(() => {
    window.dispatchEvent(new CustomEvent('sit:topbar-breadcrumb', { detail: 'Sport & Fixtures / Invites' }));
    return () => {
      window.dispatchEvent(new CustomEvent('sit:topbar-breadcrumb-clear'));
    };
  }, []);

  return (
    <div className="schoolInvitesHub">
      <header className="schoolInvitesHub__head">
        <h1>Invites</h1>
        <nav className="schoolInvitesHub__tabs" aria-label="Invite folders">
          {tabs.map(tab => {
            const isActive = pathname.indexOf(`/invites/${tab.key}`) === 0;
            return (
              <Link
                key={tab.key}
                to={`/invites/${tab.key}`}
                className={isActive ? 'schoolInvitesHub__tab is-active' : 'schoolInvitesHub__tab'}
              >
                <strong>{tab.label}</strong>
              </Link>
            );
          })}
        </nav>
      </header>
      <div className="schoolInvitesHub__content">
        <Switch>
          <Route exact path={'/invites'} render={() => <Redirect to="/invites/inbox" />} />
          <Route
            exact
            path={'/invites/inbox'}
            render={props => (
              <AdminSchoolsInvitesInbox {...props} user={allProps.user} setNeedUpdate={allProps.setNeedUpdate} />
            )}
          />
          <Route
            exact
            path={'/invites/outbox'}
            render={props => <AdminSchoolsInvitesOutbox {...props} user={allProps.user} />}
          />
          <Route
            exact
            path={'/invites/archive'}
            render={props => <AdminSchoolsInvitesArchive {...props} user={allProps.user} />}
          />
        </Switch>
      </div>
    </div>
  );
};

SchoolInvitesRouting.displayName = 'SchoolInvitesRouting';
